"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Field_1 = __importDefault(require("./Field"));
const RecommendationModel_1 = __importDefault(require("./RecommendationModel"));
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const Recommendations_1 = require("./Recommendations");
class Farm {
    constructor(farm) {
        var _a, _b;
        this.id = farm.id;
        this.name = farm.name;
        this.client_code = farm.client_code;
        this.client_name = farm.client_name;
        this.is_generative_zone = farm.is_generative_zone;
        this.total_extension = farm.total_extension;
        this.total_fields = farm.total_fields;
        this.fields = farm.fields;
        this.generative_zones = farm.generative_zones;
        this.unit = farm.unit;
        this.recommendations = ((_a = farm.recommendations) === null || _a === void 0 ? void 0 : _a.map((recommendation) => new RecommendationModel_1.default(recommendation))) || [];
        this.fields_linked_to_projects = ((_b = farm.fields) === null || _b === void 0 ? void 0 : _b.map((field) => new Recommendations_1.FieldRecommendation({
            areaID: -1,
            id: field.id,
            name: field.name,
            polygon: field.geodata,
            samples: [],
            crop: field.crop,
            acreage: field.acreage,
            eBeCropDiagnostic: null,
            positionCheck: null,
            recomendationsBrief: '',
            recomendationsAvailability: '',
            isGISField: false,
            hasResults: false,
            metrics: [],
            needMaps: []
        }, []))) || [];
    }
    setFieldsGeodata(geodataItems) {
        if (geodataItems.length > 0) {
            geodataItems.forEach((geo) => {
                const fieldIx = this.fields.findIndex((f) => f.id === geo.gis_field_id);
                if (fieldIx !== -1) {
                    this.fields[fieldIx].geodata = geo.geodata;
                }
            });
        }
    }
    setGeodata(g) {
        //this.geodata = g
    }
    async fetchFieldsGeodata() {
        try {
            if (this.fields.every((gf) => gf.geodata.length == 0)) {
                const url = `/farm/${this.id}/gis-fields/geodata`;
                const request = await fetch(url);
                const response = await request.json();
                this.setFieldsGeodata(response);
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    async fetchGeodata() {
        try {
            const url = `/farm/${this.id}/geodata`;
            const request = await fetch(url);
            const response = await request.json();
            this.setGeodata(response.geodata);
        }
        catch (e) {
            console.log(e);
        }
    }
    get brief() {
        if (this.fields.some((f) => f.status === 'has_recommendations'))
            return 'retrieved';
    }
    get acreage() {
        return new Acreage_1.default(this.total_extension, this.unit);
    }
    get cropLabel() {
        var _a, _b;
        if (((_a = this.cropsInvolved) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            return this.cropsInvolved[0].name;
        }
        else if (((_b = this.cropsInvolved) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            return `MultiCrop`;
        }
        else {
            return `No Crop`;
        }
    }
    get cropColor() {
        var _a, _b;
        if (((_a = this.cropsInvolved) === null || _a === void 0 ? void 0 : _a.length) === 1) {
            return this.cropsInvolved[0].color;
        }
        else if (((_b = this.cropsInvolved) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            return `#2A7346`;
        }
        else {
            return `#AAA9A9`;
        }
    }
    get cropsInvolved() {
        const uniqueCrops = this.fields
            .map((f) => f.crop)
            .filter((crop, index, self) => self.findIndex((c) => c.name === crop.name) === index);
        return uniqueCrops;
    }
    async downloadPDF() {
        const url = `/data/results/farm/pdf/${this.id}`;
        const link = document.createElement('a');
        link.href = url;
        document.body.appendChild(link);
        window.open(url);
    }
    setRecommendations(r) {
        this.recommendations = r;
    }
    setFieldsRecommendations(recFields) {
        recFields.forEach((rf) => {
            const fIx = this.fields.findIndex((f) => f.id == rf.id);
            if (fIx !== -1) {
                this.fields[fIx].recommendations = rf.recommendations;
            }
        });
    }
    setGenerativeZones(genZones) {
    }
    async fetchAIGENRecommendations() {
        try {
            if (this.is_generative_zone) {
                console.log('fetch recomms');
                const url = `/farms/api/${this.id}/gis-fields/aigen/recomm`;
                const request = await fetch(url);
                const response = await request.json();
                /* 				const response =
                                    {
                                      "id": 1546,
                                      "name": "TEST_Apri 15-Corn, Maize(42.03N, 85.40W)",
                                      "is_generative_zone": true,
                                      "generative_zone": {
                                        "location": true,
                                        "crop": true,
                                        "zone": {
                                          "name": "MidWest",
                                          "code_name": "midwest"
                                        },
                                        "total_fields_generative_zone": 3
                                      },
                                      "gis_fields": [
                                        {
                                          "id": 39388,
                                          "name": "3470-Outman",
                                          "status": "has_recommendations",
                                          "recommendations": [
                                            {
                                              "product": "Trichoderma",
                                              "slug": "trichoderma",
                                              "level": 2,
                                              "level_raw": 1.76,
                                              "category": {
                                                "name": "Nutrición",
                                                "slug": "nutrición"
                                              },
                                              "parents": [
                                                {
                                                  "name": "Bioestimulante microbiano",
                                                  "slug": "bioestimulante microbiano",
                                                  "order": 0,
                                                  "level": 1
                                                },
                                                {
                                                  "name": "Bioestimulante",
                                                  "slug": "bioestimulante",
                                                  "order": 0,
                                                  "level": 0
                                                }
                                              ]
                                            },
                                            {
                                              "product": "Ácidos orgánicos",
                                              "slug": "Ácidos_orgánicos",
                                              "level": 1,
                                              "level_raw": 0.68,
                                              "category": {
                                                "name": "Nutrición",
                                                "slug": "nutrición"
                                              },
                                              "parents": [
                                                {
                                                  "name": "Bioestimulante",
                                                  "slug": "bioestimulante",
                                                  "order": 0,
                                                  "level": 0
                                                },
                                                {
                                                  "name": "Bioestimulante no Microbiano",
                                                  "slug": "bioestimulante no microbiano",
                                                  "order": 1,
                                                  "level": 1
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        {
                                          "id": 39389,
                                          "name": "3480-Weiderman N",
                                          "status": "has_recommendations",
                                          "recommendations": [
                                            {
                                              "product": "Trichoderma",
                                              "slug": "trichoderma",
                                              "level": 1,
                                              "level_raw": 1.12,
                                              "category": {
                                                "name": "Nutrición",
                                                "slug": "nutrición"
                                              },
                                              "parents": [
                                                {
                                                  "name": "Bioestimulante microbiano",
                                                  "slug": "bioestimulante microbiano",
                                                  "order": 0,
                                                  "level": 1
                                                },
                                                {
                                                  "name": "Bioestimulante",
                                                  "slug": "bioestimulante",
                                                  "order": 0,
                                                  "level": 0
                                                }
                                              ]
                                            },
                                            {
                                              "product": "Ácidos orgánicos",
                                              "slug": "Ácidos_orgánicos",
                                              "level": 1,
                                              "level_raw": 0.68,
                                              "category": {
                                                "name": "Nutrición",
                                                "slug": "nutrición"
                                              },
                                              "parents": [
                                                {
                                                  "name": "Bioestimulante",
                                                  "slug": "bioestimulante",
                                                  "order": 0,
                                                  "level": 0
                                                },
                                                {
                                                  "name": "Bioestimulante no Microbiano",
                                                  "slug": "bioestimulante no microbiano",
                                                  "order": 1,
                                                  "level": 1
                                                }
                                              ]
                                            }
                                          ]
                                        },
                                        {
                                          "id": 39390,
                                          "name": "3490-Weiderman S",
                                          "status": "has_recommendations",
                                          "recommendations": [
                                            {
                                              "product": "Trichoderma",
                                              "slug": "trichoderma",
                                              "level": 1,
                                              "level_raw": 1.12,
                                              "category": {
                                                "name": "Nutrición",
                                                "slug": "nutrición"
                                              },
                                              "parents": [
                                                {
                                                  "name": "Bioestimulante microbiano",
                                                  "slug": "bioestimulante microbiano",
                                                  "order": 0,
                                                  "level": 1
                                                },
                                                {
                                                  "name": "Bioestimulante",
                                                  "slug": "bioestimulante",
                                                  "order": 0,
                                                  "level": 0
                                                }
                                              ]
                                            },
                                            {
                                              "product": "Ácidos orgánicos",
                                              "slug": "Ácidos_orgánicos",
                                              "level": 1,
                                              "level_raw": 0.68,
                                              "category": {
                                                "name": "Nutrición",
                                                "slug": "nutrición"
                                              },
                                              "parents": [
                                                {
                                                  "name": "Bioestimulante",
                                                  "slug": "bioestimulante",
                                                  "order": 0,
                                                  "level": 0
                                                },
                                                {
                                                  "name": "Bioestimulante no Microbiano",
                                                  "slug": "bioestimulante no microbiano",
                                                  "order": 1,
                                                  "level": 1
                                                }
                                              ]
                                            }
                                          ]
                                        }
                                      ],
                                      "recommendations": [
                                        {
                                          "product": "Trichoderma",
                                          "slug": "trichoderma",
                                          "level": 1,
                                          "level_raw": 1.33333333333333,
                                          "total_recommendations_avg": 3,
                                          "category": {
                                            "name": "Nutrición",
                                            "slug": "nutrición"
                                          },
                                          "parents": [
                                            {
                                              "name": "Bioestimulante microbiano",
                                              "slug": "bioestimulante microbiano",
                                              "order": 0,
                                              "level": 1
                                            },
                                            {
                                              "name": "Bioestimulante",
                                              "slug": "bioestimulante",
                                              "order": 0,
                                              "level": 0
                                            }
                                          ]
                                        },
                                        {
                                          "product": "Ácidos orgánicos",
                                          "slug": "Ácidos_orgánicos",
                                          "level": 1,
                                          "level_raw": 0.68,
                                          "total_recommendations_avg": 3,
                                          "category": {
                                            "name": "Nutrición",
                                            "slug": "nutrición"
                                          },
                                          "parents": [
                                            {
                                              "name": "Bioestimulante",
                                              "slug": "bioestimulante",
                                              "order": 0,
                                              "level": 0
                                            },
                                            {
                                              "name": "Bioestimulante no Microbiano",
                                              "slug": "bioestimulante no microbiano",
                                              "order": 1,
                                              "level": 1
                                            }
                                          ]
                                        }
                                      ]
                                    } */
                const recommendations = response.recommendations.map((r) => new RecommendationModel_1.default(Object.assign({}, r)));
                this.setRecommendations(recommendations);
                const recFields = response.gis_fields.map((g) => new Field_1.default(Object.assign({}, g)));
                this.setFieldsRecommendations(recFields);
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    async fetchAIGENStates() {
        try {
            if (this.is_generative_zone) {
                console.log('fetch zones');
                const url = `/farms/api/${this.id}/gis-fields/aigen/states`;
                const request = await fetch(url);
                const response = await request.json();
                /* 				const response = [
                                    {
                                      "url": "https://e-becrop-portal-files.s3.amazonaws.com/v2.2/hi-res/Michigan_NIT_4_16.tif?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAVPD22OF42KALKX4Z%2F20250616%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20250616T100007Z&X-Amz-SignedHeaders=host&X-Amz-Expires=1500&X-Amz-Signature=73c9d65fe25bf3ed2eddcea78976ae9c9a77d7aef1695f79db483894c6a952da",
                                      "name": "Michigan"
                                    }
                                ] */
                const genZones = response.map((g) => g);
                this.setGenerativeZones(genZones);
            }
        }
        catch (e) {
            console.log(e);
        }
    }
}
exports.default = Farm;
